<template>
  <v-expansion-panels multiple class="mb-4 gestao-card">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div class="professor-info">
          <v-avatar size="40" color="green darken-1">
            <span class="white--text text-h6">
              {{ iniciais }}
            </span>
          </v-avatar>

          <div class="flex-grow-1">
            <div class="text-subtitle-1 font-weight-medium text-uppercase">
              {{ professor.nome }}
            </div>
            <div class="text-caption text--secondary">{{ totalGestoes }} gestão(ões)</div>
          </div>

          <v-chip small :color="statusColor" text-color="white">
            {{ totalGestoes }} Gestão(ões)
          </v-chip>
        </div>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <div class="gestoes-container">
          <!-- Resumo estatístico -->
          <div class="estatisticas">
            <h5 class="text-subtitle-1 mb-2">Resumo Estatístico</h5>
            <v-row>
              <v-col cols="6" md="4" lg="2">
                <v-card
                  class="text-center pa-2 d-flex flex-column justify-center align-center min-height-92"
                  color="primary lighten-1"
                  dark
                >
                  <div class="text-h4">{{ totalGestoes }}</div>
                  <div class="text-caption">Total de Gestões</div>
                </v-card>
              </v-col>
              <v-col cols="6" md="4" lg="2">
                <v-card
                  class="text-center pa-2 d-flex flex-column justify-center align-center min-height-92"
                  color="primary"
                  dark
                >
                  <div class="text-h4">{{ totalPendenciasAulas }}</div>
                  <div class="text-caption">Pendências Aulas</div>
                </v-card>
              </v-col>
              <v-col cols="6" md="4" lg="2">
                <v-card
                  class="text-center pa-2 d-flex flex-column justify-center align-center min-height-92"
                  color="primary"
                  dark
                >
                  <div class="text-h4">{{ totalPendenciasPlanos }}</div>
                  <div class="text-caption">Pendências Planos</div>
                </v-card>
              </v-col>
              <v-col cols="6" md="4" lg="2">
                <v-card
                  class="text-center pa-2 d-flex flex-column justify-center align-center min-height-92"
                  color="primary"
                  dark
                >
                  <div class="text-h4">{{ totalPendenciasFrequencias }}</div>
                  <div class="text-caption">Pendências Frequências</div>
                </v-card>
              </v-col>
              <v-col cols="6" md="4" lg="2">
                <v-card
                  class="text-center pa-2 d-flex flex-column justify-center align-center min-height-92"
                  color="primary"
                  dark
                >
                  <div class="text-h4">{{ totalPendenciasAvaliacoes }}</div>
                  <div class="text-caption">Pendências Avaliações</div>
                </v-card>
              </v-col>
              <v-col cols="6" md="4" lg="2">
                <v-card
                  class="text-center pa-2 d-flex flex-column justify-center align-center min-height-92"
                  color="primary darken-1"
                  dark
                >
                  <div class="text-h4">{{ totalGeralPendencias }}</div>
                  <div class="text-caption">Pendências Totais</div>
                </v-card>
              </v-col>
            </v-row>
          </div>
          <v-divider class="my-4"></v-divider>
          <h4 class="text-h6 mb-3">Gestões de Aulas</h4>

          <v-row>
            <v-col v-for="(gestao, index) in professor.gestoes" :key="gestao.id" cols="12">
              <v-card
                class="gestao-card elevation-2"
                outlined
                :class="{ 'zebra-even': index % 2 === 0, 'zebra-odd': index % 2 === 1 }"
              >
                <v-card-title class="pb-2">
                  <v-row class="mb-2">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-icon left color="primary">mdi mdi-account-group</v-icon>
                      <span class="text-subtitle-1 word-break-keep">
                        <strong>Turma: </strong>
                        {{ gestao.turma }}
                      </span>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-icon left color="primary">mdi-book-open-variant</v-icon>
                      <span class="text-subtitle-1 word-break-keep">
                        <strong>Componente(s) Curricular(es):</strong>
                        {{ gestao.disciplinas_da_gestao }}
                      </span>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-icon left color="primary">mdi-school</v-icon>
                      <span class="text-subtitle-1 word-break-keep">
                        <strong>Etapas: </strong>
                        <v-chip
                          v-for="serie in gestao.series_da_turma"
                          :key="serie.id"
                          md
                          filled
                          color="primary"
                          class="mr-1 mb-1"
                        >
                          {{ serie }}
                        </v-chip>
                      </span>
                    </v-col>
                    <v-chip
                      small
                      :color="
                        textoPendenciasPorGestao(gestao) === 'Sem pendências' ? 'green' : 'red'
                      "
                      text-color="white"
                      class="ml-5 mb-1"
                      :title="textoPendenciasPorGestao(gestao)"
                    >
                      {{ textoPendenciasPorGestao(gestao) }}
                    </v-chip>
                  </v-row>
                </v-card-title>

                <v-card-text class="pt-0">
                  <div class="gestao-details">
                    <span class="text-body-1"
                      ><strong class="mb-4">Pendências por Etapa:</strong></span
                    >

                    <!-- Aulas -->
                    <div class="pendencias-details">
                      <v-card
                        class="pa-4"
                        elevation-3
                        :class="{ 'zebra-even': index % 2 === 0, 'zebra-odd': index % 2 === 1 }"
                      >
                        <v-card
                          class="text-center pa-2 d-flex flex-column justify-center align-center"
                          color="primary"
                          dark
                        >
                          <v-card-title class="pa-0">
                            <div class="text-h6">
                              <v-icon lg class="mr-2">mdi-calendar-clock</v-icon>
                              <span>Aulas</span>
                            </div>
                          </v-card-title>
                        </v-card>
                        <v-row
                          dense
                          class="mt-2"
                          v-if="
                            gestao.pendencias?.aulas &&
                            Object.keys(gestao.relacaoAulasEtapas).length > 0
                          "
                        >
                          <v-col
                            cols="12"
                            sm="6"
                            lg="3"
                            v-for="[etapa, info] in Object.entries(gestao.pendencias.aulas)"
                            :key="etapa"
                          >
                            <v-card
                              outlined
                              class="pa-2"
                              :class="{
                                'zebra-even': index % 2 === 0,
                                'zebra-odd': index % 2 === 1,
                              }"
                            >
                              <div class="text-subtitle-2">
                                <strong>{{ etapa }}</strong>
                              </div>
                              <div class="d-flex align-center mt-1">
                                <span class="text-caption mr-1">Esperadas:</span>
                                <v-chip x-small color="primary" text-color="white">
                                  {{ info.esperado }}
                                </v-chip>
                              </div>
                              <div class="d-flex align-center mt-1">
                                <span class="text-caption mr-1">Confirmadas:</span>
                                <v-chip x-small color="green" text-color="white">
                                  {{ info.confirmadas }}
                                </v-chip>
                              </div>
                              <div class="d-flex align-center mt-1">
                                <span class="text-caption mr-1">Pendentes:</span>
                                <v-chip
                                  x-small
                                  :color="info.pendentes > 0 ? 'red' : 'green'"
                                  text-color="white"
                                >
                                  {{ info.pendentes }}
                                </v-chip>
                              </div>
                            </v-card>
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12" class="mt-4 text-center">
                            <v-alert color="primary" dense outlined>
                              Quantidade de aulas por etapa não informada nesta gestão.
                            </v-alert>
                          </v-col>
                        </v-row>
                      </v-card>
                    </div>

                    <!-- Planos -->
                    <div class="pendencias-details">
                      <v-card
                        class="pa-4"
                        elevation-3
                        :class="{ 'zebra-even': index % 2 === 0, 'zebra-odd': index % 2 === 1 }"
                      >
                        <v-card
                          class="text-center pa-2 d-flex flex-column justify-center align-center"
                          color="primary"
                          dark
                        >
                          <v-card-title class="pa-0">
                            <div class="text-h6">
                              <v-icon lg class="mr-2">mdi mdi-text-box-multiple</v-icon>
                              <span>Planos</span>
                            </div>
                          </v-card-title>
                        </v-card>

                        <v-row dense class="mt-2" v-if="gestao.pendencias?.planos_bimestrais">
                          <v-col
                            cols="12"
                            sm="6"
                            lg="3"
                            v-for="[etapa, disciplinas] in Object.entries(
                              gestao.pendencias.planos_bimestrais
                            )"
                            :key="etapa"
                          >
                            <v-card
                              outlined
                              class="pa-2"
                              :class="{
                                'zebra-even': index % 2 === 0,
                                'zebra-odd': index % 2 === 1,
                              }"
                            >
                              <div class="text-subtitle-2 mb-3">
                                <strong>{{ etapa }}</strong>
                              </div>

                              <v-row dense>
                                <v-col
                                  cols="12"
                                  :lg="Object.keys(disciplinas).length > 1 ? '6' : '12'"
                                  v-for="[disciplina, info] in Object.entries(disciplinas)"
                                  :key="disciplina"
                                >
                                  <v-card
                                    outlined
                                    class="pa-2"
                                    :class="{
                                      'zebra-even': index % 2 === 0,
                                      'zebra-odd': index % 2 === 1,
                                    }"
                                  >
                                    <div class="text-subtitle-2 mb-2 border">
                                      <strong>{{ disciplina }}</strong>
                                    </div>

                                    <div class="d-flex align-center mt-1">
                                      <span class="text-caption mr-1">Enviado:</span>
                                      <v-chip
                                        x-small
                                        :color="info.tem_plano ? 'orange' : 'grey'"
                                        text-color="white"
                                      >
                                        {{ info.tem_plano ? "Sim" : "Não" }}
                                      </v-chip>
                                    </div>

                                    <div class="d-flex align-center mt-1">
                                      <span class="text-caption mr-1">Status:</span>
                                      <v-chip
                                        x-small
                                        :color="info.status_color || 'grey'"
                                        text-color="white"
                                      >
                                        {{
                                          info.status_descricao
                                            ? info.status_descricao
                                            : "indeterminado"
                                        }}
                                      </v-chip>
                                    </div>

                                    <div class="d-flex align-center mt-1">
                                      <span class="text-caption mr-1">Pendente:</span>
                                      <v-chip
                                        x-small
                                        :color="info.tem_pendencia ? 'red' : 'green'"
                                        text-color="white"
                                      >
                                        {{ info.tem_pendencia ? "Sim" : "Não" }}
                                      </v-chip>
                                    </div>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>

                        <v-row v-else>
                          <v-col cols="12" lg="6" class="mt-4">
                            <v-alert color="primary" dense outlined>
                              Nenhum plano encontrado para esta gestão.
                            </v-alert>
                          </v-col>
                        </v-row>
                      </v-card>
                    </div>

                    <!-- Avaliações -->
                    <div class="pendencias-details">
                      <v-card
                        class="pa-4"
                        elevation-3
                        :class="{ 'zebra-even': index % 2 === 0, 'zebra-odd': index % 2 === 1 }"
                      >
                        <v-card
                          class="text-center pa-2 d-flex flex-column justify-center align-center"
                          color="primary"
                          dark
                        >
                          <v-card-title class="pa-0">
                            <div class="text-h6">
                              <v-icon lg class="mr-2">mdi mdi-note-text</v-icon>
                              <span>Avaliações</span>
                            </div>
                          </v-card-title>
                        </v-card>

                        <v-row dense class="mt-2" v-if="gestao.pendencias?.avaliacoes">
                          <v-col
                            cols="12"
                            sm="6"
                            lg="3"
                            v-for="[etapa, disciplinas] in Object.entries(
                              gestao.pendencias.avaliacoes
                            )"
                            :key="etapa"
                          >
                            <v-card
                              outlined
                              class="pa-2"
                              :class="{
                                'zebra-even': index % 2 === 0,
                                'zebra-odd': index % 2 === 1,
                              }"
                            >
                              <div class="text-subtitle-2 mb-3">
                                <strong>{{ etapa }}</strong>
                              </div>

                              <v-row dense>
                                <v-col
                                  cols="12"
                                  :lg="Object.keys(disciplinas).length > 1 ? '6' : '12'"
                                  v-for="[disciplina, info] in Object.entries(disciplinas)"
                                  :key="disciplina"
                                >
                                  <v-card
                                    outlined
                                    class="pa-2"
                                    :class="{
                                      'zebra-even': index % 2 === 0,
                                      'zebra-odd': index % 2 === 1,
                                    }"
                                  >
                                    <div class="text-subtitle-2 mb-2 border">
                                      <strong>{{ disciplina }}</strong>
                                    </div>

                                    <div class="d-flex align-center mt-1">
                                      <span class="text-caption mr-1">Esperado:</span>
                                      <v-chip x-small color="primary" text-color="white">
                                        {{ info.esperado }}
                                      </v-chip>
                                    </div>

                                    <div class="d-flex align-center mt-1">
                                      <span class="text-caption mr-1">Lançadas:</span>
                                      <v-chip
                                        x-small
                                        :color="info.lancadas >= info.esperado ? 'green' : 'grey'"
                                        text-color="white"
                                      >
                                        {{ info.lancadas }}
                                      </v-chip>
                                    </div>

                                    <div class="d-flex align-center mt-1">
                                      <span class="text-caption mr-1">Pendentes:</span>
                                      <v-chip
                                        x-small
                                        :color="info.pendentes > 0 ? 'red' : 'green'"
                                        text-color="white"
                                      >
                                        {{ info.pendentes }}
                                      </v-chip>
                                    </div>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>

                        <v-row v-else>
                          <v-col cols="12" lg="6" class="mt-4">
                            <v-alert color="primary" dense outlined>
                              Nenhuma avaliação encontrada para esta gestão.
                            </v-alert>
                          </v-col>
                        </v-row>
                      </v-card>
                    </div>

                    <!-- Frequência -->
                    <div class="pendencias-details">
                      <v-card
                        class="pa-4"
                        elevation-3
                        :class="{ 'zebra-even': index % 2 === 0, 'zebra-odd': index % 2 === 1 }"
                      >
                        <v-card
                          class="text-center pa-2 d-flex flex-column justify-center align-center"
                          color="primary"
                          dark
                        >
                          <v-card-title class="pa-0">
                            <div class="text-h6">
                              <v-icon lg class="mr-2">mdi mdi-calendar-check</v-icon>
                              <span>Frequências</span>
                            </div>
                          </v-card-title>
                        </v-card>
                        <v-row dense class="mt-2" v-if="gestao.pendencias?.frequencias">
                          <v-col
                            cols="12"
                            sm="6"
                            lg="3"
                            v-for="[etapa, info] in Object.entries(gestao.pendencias.frequencias)"
                            :key="etapa"
                          >
                            <v-card
                              outlined
                              class="pa-2"
                              :class="{
                                'zebra-even': index % 2 === 0,
                                'zebra-odd': index % 2 === 1,
                              }"
                            >
                              <div class="text-subtitle-2">
                                <strong>{{ etapa }}</strong>
                              </div>
                              <div class="d-flex align-center mt-1">
                                <span class="text-caption mr-1">Aulas confirmadas:</span>
                                <v-chip x-small color="primary" text-color="white">
                                  {{ info.aulas_confirmadas }}
                                </v-chip>
                              </div>
                              <div class="d-flex align-center mt-1">
                                <span class="text-caption mr-1">Frequências confirmadas:</span>
                                <v-chip
                                  x-small
                                  :color="
                                    info.frequencias_confirmadas >= info.aulas_confirmadas
                                      ? 'green'
                                      : 'grey'
                                  "
                                  text-color="white"
                                >
                                  {{ info.frequencias_confirmadas }}
                                </v-chip>
                              </div>
                              <div class="d-flex align-center mt-1">
                                <span class="text-caption mr-1">Pendentes:</span>
                                <v-chip
                                  x-small
                                  :color="info.pendentes > 0 ? 'red' : 'green'"
                                  text-color="white"
                                >
                                  {{ info.pendentes }}
                                </v-chip>
                              </div>
                            </v-card>
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12" lg="6" class="mt-4">
                            <v-alert color="primary" dense outlined>
                              Sem pendencias de frequência para esta gestão.
                            </v-alert>
                          </v-col>
                        </v-row>
                      </v-card>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: "ProfessorExpansionItem",

  props: {
    professor: {
      type: Object,
      required: true,
    },
  },

  computed: {
    textoPendenciasPorGestao() {
      return (gestao) => {
        const pendenciaTypes = [];

        if (gestao.pendencias?.totais?.aulas > 0) pendenciaTypes.push("Aulas");
        if (gestao.pendencias?.totais?.frequencias > 0) pendenciaTypes.push("Frequências");
        if (gestao.pendencias?.totais?.avaliacoes > 0) pendenciaTypes.push("Avaliações");
        if (gestao.pendencias?.totais?.planos_bimestrais > 0) pendenciaTypes.push("Planos");

        if (pendenciaTypes.length === 0) {
          return "Sem pendências";
        }

        return `Pendente em: ${pendenciaTypes.join(", ")}`;
      };
    },
    iniciais() {
      if (!this.professor.nome) return "N/A";

      const nomes = this.professor.nome.split(" ");
      if (nomes.length === 1) {
        return nomes[0].substring(0, 2).toUpperCase();
      }

      return (nomes[0][0] + nomes[nomes.length - 1][0]).toUpperCase();
    },

    totalGestoes() {
      return this.professor.gestoes?.length || 0;
    },

    totalPendenciasAulas() {
      if (!this.professor.gestoes) return 0;
      return this.professor.gestoes.reduce((total, gestao) => {
        return total + (gestao.pendencias?.totais?.aulas || 0);
      }, 0);
    },

    totalPendenciasFrequencias() {
      if (!this.professor.gestoes) return 0;
      return this.professor.gestoes.reduce((total, gestao) => {
        return total + (gestao.pendencias?.totais?.frequencias || 0);
      }, 0);
    },

    totalPendenciasAvaliacoes() {
      if (!this.professor.gestoes) return 0;
      return this.professor.gestoes.reduce((total, gestao) => {
        return total + (gestao.pendencias?.totais?.avaliacoes || 0);
      }, 0);
    },

    totalPendenciasPlanos() {
      if (!this.professor.gestoes) return 0;
      return this.professor.gestoes.reduce((total, gestao) => {
        return total + (gestao.pendencias?.totais?.planos_bimestrais || 0);
      }, 0);
    },

    totalGeralPendencias() {
      if (!this.professor.gestoes) return 0;
      return this.professor.gestoes.reduce((total, gestao) => {
        return total + (gestao.pendencias?.totais?.geral || 0);
      }, 0);
    },

    statusColor() {
      let tiposPendencias = 0;

      if (this.totalPendenciasAulas > 0) tiposPendencias++;
      if (this.totalPendenciasFrequencias > 0) tiposPendencias++;
      if (this.totalPendenciasAvaliacoes > 0) tiposPendencias++;
      if (this.totalPendenciasPlanos > 0) tiposPendencias++;

      switch (tiposPendencias) {
        case 0:
          return "green";
        case 1:
          return "warning";
        case 2:
          return "orange";
        case 3:
          return "error";
        default:
          return "error";
      }
    },
  },
  data() {
    return {
      painelAberto: [0],
    };
  },
};
</script>

<style scoped>
.professor-info {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.professor-avatar {
  flex-shrink: 0;
}

.gestao-card {
  border-left: 4px solid #4caf50; /* green  */
  transition: all 0.3s ease;
}

.zebra-even {
  background-color: #ffffff !important;
}

.zebra-odd {
  background-color: #f5f5f5 !important;
}

.pendencias-details {
  margin-bottom: 22px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.border-top-aulas {
  border-top: 4px solid #ffb74d;
  /* orange lighten-2 */
}

.border-top-planos {
  border-top: 4px solid #039be5;
  /* light-blue darken-1 */
}

.border-top-notas {
  border-top: 4px solid #ba68c8;
  /* purple lighten-2 */
}

.border-top-frequencias {
  border-top: 4px solid #e57373;
  /* red lighten-2 */
}

/* .gestao-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
} */

.detail-item {
  display: flex;
  align-items: flex-start;
}

.gestoes-container {
  padding: 0 8px;
}

.estatisticas .v-card {
  transition: all 0.3s ease;
}

.estatisticas .v-card:hover {
  transform: scale(1.05);
}

.word-break-keep {
  word-break: keep-all;
}
.min-height-92 {
  min-height: 92px;
}

/* Responsividade */
@media (max-width: 600px) {
  .professor-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .professor-info .v-chip {
    align-self: flex-end;
  }
}
</style>
